import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['sidebar', 'overlay', 'button'];

  toggle() {
    this.sidebarTarget.classList.toggle('-translate-x-full');
    this.overlayTarget.classList.toggle('hidden');
    this.buttonTarget.classList.toggle('hidden');
  }

  close() {
    this.sidebarTarget.classList.add('-translate-x-full');
    this.overlayTarget.classList.add('hidden');
    this.buttonTarget.classList.remove('hidden');
  }

  connect() {
    // On mobile, start with sidebar hidden
    if (window.innerWidth < 1024) {
      this.sidebarTarget.classList.add('-translate-x-full');
    }
  }
}
